import { UUID } from "shared-ts/classes/uuid"
import { defModalId } from "shared-web/components/base/overlay/Modal"
import { Modal } from "shared-web/components/base/overlay/Modal/Modal"
import { Table } from "shared-web/components/composite/TableV2/Table"
import { TableScrollContainer } from "shared-web/components/composite/TableV2/TableScrollContainer"

import { useReceivableHistoryTable } from "./useReceivableHistoryTable"
import { CreditHistoryHeader } from "../Credit/CreditHistoryHeader"

export const receivableHistoryModalId = defModalId("ReceivableHistoryModal")

interface ReceivableHistoryModalProps {
  ledgerEntryId: UUID
}

export function ReceivableHistoryModal(props: ReceivableHistoryModalProps) {
  return (
    <Modal id={receivableHistoryModalId} size="md">
      <ReceivableHistoryModalContent {...props} />
    </Modal>
  )
}

function ReceivableHistoryModalContent({
  ledgerEntryId,
}: ReceivableHistoryModalProps) {
  const { tableProps, receivable } = useReceivableHistoryTable({
    ledgerEntryId,
  })
  if (!receivable) return null

  return (
    <div className="flex flex-col gap-y-4">
      <CreditHistoryHeader
        kind={receivable.kind}
        identifier={receivable.identifier}
        txnIdentifier={receivable.transaction.identifier}
        locationPrefix={receivable.location.prefix}
        txnId={receivable.transaction.id}
        txnType={receivable.transaction.type}
        createdAt={receivable.date}
        createdBy={receivable.staffName}
      />
      <div>
        <TableScrollContainer>
          <Table {...tableProps} />
        </TableScrollContainer>
      </div>
    </div>
  )
}
